import { userActionTypes } from '@Actions/userActions';

const UserReducer = (state = {}, action) => {
  switch (action.type) {
  case userActionTypes.REQUEST_OTP.LOADING: {
    const { requestOtpLoading } = action;
    return {
      ...state,
      requestOtpLoading,
    };
  }
  case userActionTypes.REQUEST_OTP.SUCCESS: {
    const { requestOtpResponse, requestType, requestValue } = action;
    return {
      ...state,
      otpRequestResponse: {
        ...requestOtpResponse,
        requestType,
        requestValue,
        requestOtpError: null,
      },
    };
  }
  case userActionTypes.REQUEST_OTP.ERROR: {
    const { otpError } = action;
    return {
      ...state,
      otpError,
    };
  }
  case userActionTypes.VERIFY_OTP.LOADING: {
    const { verifyOtpLoading } = action;
    return {
      ...state,
      verifyOtpLoading,
    };
  }
  case userActionTypes.VERIFY_OTP.SUCCESS: {
    const { userInfo } = action;
    return {
      ...state,
      user: userInfo.user,
      isAuthenticated: true,
      otpRequestResponse: null,
      showLoginModal: false,
    };
  }
  case userActionTypes.GET_USER_PROFILE.LOADING: {
    const { getUserProfileLoading } = action;
    return {
      ...state,
      getUserProfileLoading,
    };
  }
  case userActionTypes.GET_USER_PROFILE.SUCCESS: {
    const { user } = action;
    const userCurrency = user?.user_tenants?.[0]?.currency_code || 'INR';
    const precision = user?.tenant_info?.global_config?.settings?.price_precision || 2;

    const MONEY = (input, currency) => {
      const formatCurrency = currency || userCurrency;

      if (formatCurrency === "INR") {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: formatCurrency,
          maximumFractionDigits: precision,
        }).format(input);
      } else {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: formatCurrency,
          maximumFractionDigits: precision,
        }).format(input);
      }
    };

    const priceMasking = {
      isDataMaskingPolicyEnable: !!user?.data_masking_policy_id,
      isHideCostPrice: !!user?.data_masking_policy_info?.hide_cost_price,
      isHideSellingPrice: !!user?.data_masking_policy_info?.hide_selling_price,
    };

    return {
      ...state,
      user,
      isAuthenticated: true,
      MONEY,
      MONEY_ABSOLUTE: new Intl.NumberFormat('en-IN', { style: 'currency', currency: userCurrency, maximumFractionDigits: 0 }),
      MONEY_SYMBOL: new Intl.NumberFormat('en-IN', { style: 'currency', currency: userCurrency, maximumFractionDigits: precision }).format(0)?.slice(0, 1),
      MONEY_FORMATTER: new Intl.NumberFormat('en-IN', { style: 'currency', currency: userCurrency, maximumFractionDigits: precision }),
      priceMasking,
    };
  }
  case userActionTypes.SIGN_UP_USER.LOADING: {
    const { signupUserLoading } = action;
    return {
      ...state,
      signupUserLoading,
    };
  }
  case userActionTypes.SIGN_UP_USER.SUCCESS: {
    const { signupUserInfo } = action;
    return {
      ...state,
      signupUserInfo,
      signupError: null,
    };
  }
  case userActionTypes.SIGN_UP_USER.ERROR: {
    const { signupError } = action;
    return {
      ...state,
      signupError,
    };
  }
  case userActionTypes.SIGN_UP_USER_FAST.LOADING: {
    const { signupUserFastLoading } = action;
    return {
      ...state,
      signupUserFastLoading,
    };
  }
  case userActionTypes.SIGN_UP_USER_FAST.SUCCESS: {
    const { signupUserInfoFast } = action;
    return {
      ...state,
      signupUserInfoFast,
      signupfastError: null,
    };
  }
  case userActionTypes.SIGN_UP_USER_FAST.ERROR: {
    const { signupFastError } = action;
    return {
      ...state,
      signupFastError,
    };
  }
  case userActionTypes.VERIFY_SIGNUP_OTP.LOADING: {
    const { verifySignupOtpLoading } = action;
    return {
      ...state,
      verifySignupOtpLoading,
    };
  }
  case userActionTypes.VERIFY_SIGNUP_OTP.SUCCESS: {
    const { userInfo } = action;
    return {
      ...state,
      user: userInfo,
      signupUserInfo: null,
      isAuthenticated: true,
      showLoginModal: false,
    };
  }
  case userActionTypes.VERIFY_SIGNUP_OTP.ERROR: {
    const { verifySignupOtpError } = action;
    return {
      ...state,
      verifySignupOtpError,
    };
  }
  case userActionTypes.VERIFY_OTP.ERROR: {
    const { error } = action;
    return {
      ...state,
      verifyOtpError: error,
    };
  }
  case userActionTypes.LOGOUT_USER.LOADING: {
    const { logoutUserLoading } = action;
    return {
      ...state,
      logoutUserLoading,
    };
  }
  case userActionTypes.LOGOUT_USER.SUCCESS: {
    return {
      ...state,
      isAuthenticated: false,
      user: null,
    };
  }
  case userActionTypes.RESEND_OTP.LOADING: {
    const { resendOtpLoading } = action;
    return {
      ...state,
      resendOtpLoading,
    };
  }
  case userActionTypes.REQUEST_CALLBACK.LOADING: {
    const { requestCallbackLoading } = action;
    return {
      ...state,
      requestCallbackLoading,
    };
  }
  case userActionTypes.TOGGLE_LOGIN_MODAL.REQUEST: {
    const { showLoginModal } = action;
    return {
      ...state,
      showLoginModal,
    };
  }

  case userActionTypes.TOGGLE_OFFER_MODAL.REQUEST: {
    const { toggleOfferModalState } = action;
    return {
      ...state,
      toggleOfferModalState,
    };
  }
  case userActionTypes.GET_USERS.LOADING: {
    const { getUsersLoading } = action;
    return {
      ...state,
      getUsersLoading,
    };
  }
  case userActionTypes.GET_USERS.SUCCESS: {
    const { users } = action;
    return {
      ...state,
      users,
    };
  }
  case userActionTypes.GET_ROLES.LOADING: {
    const { getRolesLoading } = action;
    return {
      ...state,
      getRolesLoading,
    };
  }
  case userActionTypes.GET_ROLES.SUCCESS: {
    const { roles } = action;
    return {
      ...state,
      roles,
    };
  }
  case userActionTypes.GET_PERMISSIONS.LOADING: {
    const { getPermissionsLoading } = action;
    return {
      ...state,
      getPermissionsLoading,
    };
  }
  case userActionTypes.GET_PERMISSIONS.SUCCESS: {
    const { permissions } = action;
    return {
      ...state,
      permissions,
    };
  }
  case userActionTypes.CREATE_USER.LOADING: {
    const { createUserLoading } = action;
    return {
      ...state,
      createUserLoading,
    };
  }
  case userActionTypes.UPDATE_PERMISSION.LOADING: {
    const { updateRoleLoading } = action;
    return {
      ...state,
      updateRoleLoading,
    };
  }
  case userActionTypes.UPDATE_USER.LOADING: {
    const { updateUserLoading } = action;
    return {
      ...state,
      updateUserLoading,
    };
  }
  case userActionTypes.UPDATE_ORG.LOADING: {
    const { updateOrgLoading } = action;
    return {
      ...state,
      updateOrgLoading,
    };
  }
  case userActionTypes.INIT_PERMISSION.LOADING: {
    const { initPermissionsLoading } = action;
    return {
      ...state,
      initPermissionsLoading,
    };
  }
  case userActionTypes.GET_ORG.LOADING: {
    const { getOrgLoading } = action;
    return {
      ...state,
      getOrgLoading,
    };
  }
  case userActionTypes.GET_ORG.SUCCESS: {
    const { org } = action;
    return {
      ...state,
      org,
    };
  }
  case userActionTypes.CREATE_ROLE.LOADING: {
    const { createRoleLoading } = action;
    return {
      ...state,
      createRoleLoading,
    };
  }
  case userActionTypes.GET_PENDING_ACTIONS.LOADING: {
    const { getPendingActionsLoading } = action;
    return {
      ...state,
      getPendingActionsLoading,
    };
  }
  case userActionTypes.GET_PENDING_ACTIONS.SUCCESS: {
    const { pendingActions } = action;
    return {
      ...state,
      pendingActions,
    };
  }
  default: {
    return state;
  }
  }
};

export default UserReducer;
